import { Avatar, Col, Divider, Empty, Row, Select, Spin } from "antd";
import React, { useEffect } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { StaffModel } from "states/staff/staff.models";
import { staffListSelector } from "states/staff/staff.slice";
import { formatPhoneNumber } from "shared/plugins/string-helper";
import { DefaultOptionType } from "antd/lib/select";
export interface IStaffSelectorProps {
  value?: number | number[];
  isMultiple?: boolean;
  onChange?: (values?: StaffModel | StaffModel[]) => void;
  bordered?: boolean;
  textAlign?: "right";
}

export function StaffSelector(props: IStaffSelectorProps) {
  const { value, isMultiple, onChange, bordered, textAlign } = props;
  const staffList = useSelector(staffListSelector, shallowEqual);
  useEffect(() => {
    if (!value && staffList.length === 1 && onChange) {
      if (isMultiple) {
        onChange(staffList);
      } else {
        onChange(staffList[0]);
      }
    }
  }, [staffList]);

  return (
    <React.Fragment>
      <Select
        className={`staff-selector w-100${
          textAlign ? ` text-${textAlign}` : ""
        }`}
        placeholder="Chọn nhân viên"
        value={value}
        onChange={(e) => {
          if (onChange) {
            if (!isMultiple) {
              const staff = staffList.find((m) => m.id === e);
              onChange(staff);
              return;
            }
            if (!e) {
              onChange([]);
              return;
            }
            const ids = e as number[];
            let staffs = [...staffList].filter((staff) =>
              ids.includes(staff.id)
            );
            onChange(staffs);
          }
        }}
        showSearch
        filterOption={(input, option: any) =>
          option.title?.toLowerCase().indexOf(input?.toLowerCase()) >= 0
        }
        mode={isMultiple ? "multiple" : undefined}
        allowClear
        bordered={bordered}
        options={staffList.map(
          (staff) =>
            ({
              key: staff.id,
              value: staff.id,
              title: `${staff.lastName} ${staff.firstName} ${formatPhoneNumber(
                staff?.phone
              )}`,
              label: (
                <Row gutter={[12, 12]}>
                  <Col>
                    <b>
                      {staff?.lastName} {staff?.firstName}
                    </b>{" "}
                    <span>{formatPhoneNumber(staff?.phone)}</span>
                  </Col>
                </Row>
              ),
            } as  DefaultOptionType)
        )}
        notFoundContent={<Empty />}
      ></Select>
    </React.Fragment>
  );
}
